<a class="skip-to-content-link" href="#wvre-main">Skip to content</a>

<header class="wvr-components wvr-header bg-{{themeVariant}}" #animationRoot>

  <nav class="top-nav navbar navbar-expand-lg bg-{{topNavThemeVariant}}">
    <div class="container">
      <a class="navbar-brand d-flex" [href]="logoHref" [id]="logoId">
        <img alt="Logo" class="logo-img d-inline-block align-top" [src]='logoSrc' />
        <span class="align-self-center d-inline-block pl-1">
          <wvr-text-component [themeVariant]="topNavThemeVariant ? topNavThemeVariant : themeVariant" [value]="logoText"></wvr-text-component>
        </span>
      </a>
      <div class="top-nav-wrapper" top-navigation [hidden]="isMobileLayout">
        <ng-content select="template[top-navigation]"></ng-content>
      </div>
    </div>
  </nav>

  <div class="title-row row m-0 bg-{{titleRowThemeVariant}}">
    <div class="container d-flex align-items-center">
      <a *ngIf="headerTitleUrl" [href]="headerTitleUrl"><span class="h1">{{headerTitle}}</span></a>
      <span *ngIf="!headerTitleUrl" class="h1">
        <wvr-text-component [themeVariant]="titleRowThemeVariant" [value]="headerTitle"></wvr-text-component>
      </span>
    </div>
  </div>

  <nav class="bottom-nav navbar navbar-expand-lg bg-{{bottomNavThemeVariant}}" [hidden]="isBottomNavHidden || isMobileLayout">
    <div class="container">
      <div class="flex-fill align-self-stretch h-100" bottom-navigation>
        <ng-content select="template[bottom-navigation]"></ng-content>
      </div>
    </div>
  </nav>

</header>

<nav class="mobile-menu" [ngClass]="{'closed': mobileMenuClosed}" [hidden]="!isMobileLayout">
  <div class="mobile-menu-header">
    <div class="mobile-menu-close" (click)="toggleMobileMenu()">
      <span>
        <wvre-text-component value="Close" font-size="0.75em"></wvre-text-component>
      </span>
      <svg class="bi bi-x" width="1.25em" height="1.25em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" d="M11.854 4.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708-.708l7-7a.5.5 0 0 1 .708 0z"/>
        <path fill-rule="evenodd" d="M4.146 4.146a.5.5 0 0 0 0 .708l7 7a.5.5 0 0 0 .708-.708l-7-7a.5.5 0 0 0-.708 0z"/>
      </svg>
    </div>
  </div>
  <div class="mobile-menu-content flex-fill align-self-stretch" mobile-menu>
    <ng-content select="template[mobile-menu]"></ng-content>
  </div>
</nav>

<div class="container" class="mobile-menu-button" [hidden]="!isMobileLayout">
  <svg
    (click)="toggleMobileMenu()"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="feather feather-menu mobile-menu-button">
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="12" x2="21" y2="12" />
    <line x1="3" y1="18" x2="21" y2="18" />
  </svg>
</div>